{
  "es": {
    "announcement": {
      "actions": {
        "allUpdates": "Todas las novedades",
        "delete_announcement": "Eliminar novedad",
        "edit": "Editar",
        "new": "Novedad",
        "pin": "Fijar arriba",
        "retry": "Reintentar",
        "save": "Guardar",
        "submit": "Publicar",
        "unpin": "Dejar de fijar"
      },
      "attributes": {
        "description": "Descripción"
      },
      "labels": {
        "allUnits": "todas las unidades",
        "archiveSubtitle": "Todo lo que publicamos sobre {project}, lo más reciente primero.",
        "customers": "clientes",
        "descriptionForCustomers": "Descripción para clientes",
        "for": "para",
        "image_tab": "Imagen",
        "notSeenYet": "Aún no vista",
        "now": "Ahora",
        "pinned": "Esta novedad se muestra arriba de la página del cliente.",
        "pinnedBadge": "Fijada",
        "seen": "Vista",
        "seenByCount": "Visto por {count} de {total}",
        "sharedWithPrefix": "Compartido con",
        "sharedWithProject": "Compartido con {units} de {project}",
        "someUnits": "algunas unidades",
        "start": "Inicio",
        "unitsCount": "1 unidad | {count} unidades",
        "video_tab": "Vídeo",
        "youtube_video": "URL del vídeo de YouTube"
      },
      "name": "Novedad",
      "placeholders": {
        "customers": {
          "failed": {
            "subtitle": "Revisa tu conexión e inténtalo de nuevo.",
            "title": "No se pudieron cargar las novedades"
          },
          "missing": {
            "title": "Esta novedad ya no está disponible"
          },
          "none": {
            "subtitle": "Pronto encontrarás actualizaciones periódicas sobre la obra en tu inicio.",
            "title": "¡Aquí verás las novedades!"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Da la bienvenida a tus clientes o comparte una actualización del proyecto.",
            "title": "Crea tu primera novedad"
          },
          "none": {
            "project_required": "Selecciona un proyecto",
            "selectProject": "Selecciona un proyecto y empieza a crear.",
            "subtitle": "Da la bienvenida a tus clientes o comparte una actualización de cualquier proyecto."
          },
          "paste_video_url": "Pega aquí tu enlace de YouTube"
        }
      },
      "toasts": {
        "create": "Novedad publicada",
        "delete": "Novedad eliminada",
        "invalid_video": "Este no es un vídeo de YouTube válido",
        "update": "La novedad se ha actualizado"
      },
      "validation": {
        "pleaseAddContent": "Añade una imagen, un vídeo o una descripción"
      }
    }
  }
}
